import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const editHistoryByClientSlice = createSlice({
    name: 'editHistoryByClient',
    initialState: {},
    reducers: {
        setEditHistoryByClient: (state, action) => {
            const { data, clientId } = action.payload;

            if (!data) return;

            const newData = data.map((dt) => {
                const { id, change_data, supplementaryData } = dt;
                return { id, change_data, supplementaryData };
            });
            return { ...state, [clientId]: newData };
        },
        resetEditHistoryByClient: () => {
            return {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return {};
        });
    }
});

export const { setEditHistoryByClient, resetEditHistoryByClient } =
    editHistoryByClientSlice.actions;

export const selectEditHistoryByClient = (state) => state.editHistoryByClient;
export default editHistoryByClientSlice.reducer;
